import IndividualTable from "../../../IndividualTable";
import { sampleData2 } from "../../sampleData";

const Distance90 = () => {
  let winners = ["219", "276"];
  return <IndividualTable matchType={"4"} gender="F" event="90" subTitle="TarscaShild" data={sampleData2} topRankCount="2" winners={winners} />;
};
export default Distance90;
